import {api} from './requestGraphql.js'

const getRates = async () => {

  try {

    const res = await api.post(
      '', {
        query: `
          {
           getRates{
              id
              name
              rate
              dateAdded
            }
          }
        `,
      }
    );
    const response = res.data.data.getRates;
    console.log(`getRates response count :`, response.length);
    return response
  } catch (e) {
    console.log(e)
  }

};

const createRates = async (data) => {

  let ratesData = JSON.stringify(data).replace(/"/g, '\\"')

  try {
    const res = await api.post(
      '', {
        query: `
          mutation{
            createRates(
              rates:"${ratesData}"
            ){
              id
              rate
            }
          },

        `,
      }
    );

    let response = res.data.data.createRates
    console.log(`\nCreateMassRates : { ${JSON.stringify(response)} } `);
    return response
  } catch (e) {
      console.log(e)
  }

}


export default {
 getRates,
 createRates
}
